// extracted by mini-css-extract-plugin
module.exports = {"AppBootstrap":"AppBootstrap_AppBootstrap__3Xi0Z","page-container":"AppBootstrap_page-container__3Mp8w"};